<template>
  <ak-display-table v-if="loading" rows cosy hover>
    <ak-display-table-row
      v-for="(item, index) in list"
      :key="index"
      pointer
      class="c-skeleton-loading"
    >
      <ak-pack>
        <ak-pack-item>
          <div class="c-screenshot width-100 h-75 bb b--white" />
        </ak-pack-item>
        <ak-pack-item>
          <div class="c-faux-text c-faux-text--bigger width-125" />
          <div>
            <p class="c-faux-text width-100 mb-none"></p>
          </div>
        </ak-pack-item>
      </ak-pack>
    </ak-display-table-row>
  </ak-display-table>
</template>

<script>
import DisplayTable from '@akerolabs/akero-vue/src/components/displayTable/DisplayTable.vue'
import DisplayTableRow from '@akerolabs/akero-vue/src/components/displayTable/DisplayTableRow.vue'
import DisplayTableCell from '@akerolabs/akero-vue/src/components/displayTable/DisplayTableCell.vue'
import Pack from '@akerolabs/akero-vue/src/components/pack/Pack.vue'
import PackItem from '@akerolabs/akero-vue/src/components/pack/PackItem.vue'

import { defineComponent, ref } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-apps-list-table-loading />
   */
  name: 'AkAppsListTableLoading',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [DisplayTable.name]: DisplayTable,
    [DisplayTableRow.name]: DisplayTableRow,
    [DisplayTableCell.name]: DisplayTableCell,
    [Pack.name]: Pack,
    [PackItem.name]: PackItem,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    loading: {
      default: false,
      type: Boolean,
    },
  },

  /**
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup() {
    const list = ref(Array(10))

    return {
      list,
    }
  },
})
</script>
